<template>

    <div class="breadcrumb d-inline-block">
        <router-link v-for="(value, i) in breadcrumb_array_object" :key="i" :to="value.href" :style="i !== 0 ? 'margin-left:4px;' : ''" v-html="value.name + ' ' + value.arrow"/>
    </div>

</template>

<script>
export default {
    props:[
        'breadcrumb',
    ],

    name:   'BreadcrumbVueRouter',

    data(){
        return{
            breadcrumb_array_object:    this.breadcrumb,
        }
    },
    methods:{
        goRoute(route){
            this.$router.push(route)
        },

    },
    mounted(){
    }
}
</script>